import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/apiClient'
import type { components } from '../lib/api-types'

export type Project = components['schemas']['Project']

/** Server state: the enrolled project directory, via the typed client. */
export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async (): Promise<Project[]> => {
      const { data, error } = await api.GET('/v1/projects')
      if (error) throw new Error('Failed to load projects')
      return data ?? []
    },
  })
}
